<template>
  <BusiformList />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
